import { render, staticRenderFns } from "./BookItem.vue?vue&type=template&id=49c29264&scoped=true&"
import script from "./BookItem.vue?vue&type=script&lang=js&"
export * from "./BookItem.vue?vue&type=script&lang=js&"
import style0 from "./BookItem.vue?vue&type=style&index=0&id=49c29264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c29264",
  null
  
)

export default component.exports